import { useState } from "react";

interface CodeBlockProps {
  label?: string;
  code: string;
}

// 文档页通用代码块：等宽字体 + 复制按钮，深色底便于阅读代码。
export default function CodeBlock({ label, code }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="overflow-hidden rounded-lg border border-foreground-800 bg-foreground-950">
      <div className="flex items-center justify-between gap-3 border-b border-foreground-800 px-4 py-2.5">
        <span className="flex items-center gap-2 text-xs font-medium text-background-300">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-code-line" />
          </span>
          {label ?? "示例"}
        </span>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-700 px-2.5 py-1 text-[11px] text-background-300 transition-colors hover:border-background-400 hover:text-background-50"
        >
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className={copied ? "ri-check-line" : "ri-file-copy-line"} />
          </span>
          {copied ? "已复制" : "复制"}
        </button>
      </div>
      <pre className="overflow-x-auto px-4 py-3.5 text-xs leading-relaxed text-background-100">
        <code className="font-mono">{code}</code>
      </pre>
    </div>
  );
}